import React from "react";
import Loadable from "react-loadable";

import DefaultLayout from "./containers/DefaultLayout";

function Loading() {
  return <div>Loading...</div>;
}

const DevelopmentMenu = {
  name: "Development",
  path: "/development",
  exact: true,
  icon: 'fa fa-code'
};

const TransformationsMenu = {
  name: "Transformations",
  path: `${DevelopmentMenu.path}/transformations`,
  exact: true,
  icon: 'icon-shuffle'
};

const ExtrasMenu = {
  name: "Extras",
  path: `${DevelopmentMenu.path}/extras`,
  exact: true,
  icon: 'icon-plus'
};

const GroupingMenu = {
  name: "Grouping",
  path: `${DevelopmentMenu.path}/grouping`,
  exact: true,
  icon: 'icon-folder'
};

const ManagementMenu = {
  name: "Management",
  path: "/management",
  exact: true,
  icon: 'icon-list'
};

const CredentialsMenu = {
  name: "Credentials",
  path: `${ManagementMenu.path}/credentials`,
  exact: true,
  icon: 'icon-shield'
};

const TroubleshootingMenu = {
  name: "Troubleshooting",
  path: "/troubleshooting",
  exact: true,
  icon: 'icon-wrench'
};

const ControlMenuRoute = {
  name: "Control",
  path: "/control",
  exact: true,
  icon: 'icon-support'
};

export const ArtifactTesterRoute = {
  name: "Test",
  path: `${DevelopmentMenu.path}/:artifact(flows|transformations/jsonhl7|transformations/jsonjson|transformations/templates|transformations/mappings)/:id/test`,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/test"),
    loading: Loading,
  }),
};

export const ConnectorConfigurationListRoute = {
  name: "Connectors",
  path: `${ManagementMenu.path}/connectors`,
  docPath: "connector-management",
  apiPath: 'connector-configurations',
  exact: true,
  icon: 'icon-equalizer',
  component: Loadable({
    loader: () => import("./views/configurations/connectors/list"),
    loading: Loading,
  })
};

export const ConnectorConfigurationEditRoute = {
  name: "Connector",
  path: `${ConnectorConfigurationListRoute.path}/:id`,
  docPath: "connector-management",
  apiPath: ConnectorConfigurationListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/configurations/connectors/edit"),
    loading: Loading,
  })
};

export const FlowConfigurationListRoute = {
  name: "Flows",
  path: `${ManagementMenu.path}/flows`,
  docPath: "flow-management",
  apiPath: 'flow-configurations',
  exact: true,
  icon: 'icon-layers',
  component: Loadable({
    loader: () => import("./views/configurations/flows/list"),
    loading: Loading,
  })
};

export const FlowConfigurationEditRoute = {
  name: "Flow",
  path: `${FlowConfigurationListRoute.path}/:id`,
  docPath: "flow-management",
  apiPath: FlowConfigurationListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/configurations/flows/edit"),
    loading: Loading,
  })
};

export const RouteConfigurationListRoute = {
  name: "Routes",
  path: `${ManagementMenu.path}/routes`,
  docPath: "route-management",
  apiPath: 'route-configurations',
  exact: true,
  icon: 'icon-directions',
  component: Loadable({
    loader: () => import("./views/configurations/routes/list"),
    loading: Loading,
  })
};

export const RouteConfigurationEditRoute = {
  name: "Route",
  path: `${RouteConfigurationListRoute.path}/:id`,
  docPath: "route-management",
  apiPath: RouteConfigurationListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/configurations/routes/edit"),
    loading: Loading,
  })
};

export const GlobalConfigurationRoute = {
  name: "Global Configurations",
  path: `${ManagementMenu.path}/globals`,
  exact: true,
  hidden: true,
  icon: 'icon-settings',
  component: Loadable({
    loader: () => import("./views/configurations/globals"),
    loading: Loading,
  })
};

export const DashboardRoute = {
  name: "Dashboard",
  path: "/dashboard",
  exact: true,
  icon: 'icon-speedometer',
  component: Loadable({
    loader: () => import("./views/dashboard"),
    loading: Loading,
  }),
};

export const TokenCredentialListRoute = {
  name: "Tokens",
  path: `${CredentialsMenu.path}/tokens`,
  docPath: 'token-list',
  apiPath: 'credentials/tokens',
  exact: true,
  icon: 'icon-lock',
  component: Loadable({
    loader: () => import("./views/credentials/tokens/list"),
    loading: Loading,
  })
};

export const TokenCredentialEditRoute = {
  name: "Token",
  path: `${TokenCredentialListRoute.path}/:id`,
  docPath: 'token-edit',
  apiPath: TokenCredentialListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/credentials/tokens/edit"),
    loading: Loading,
  })
};

export const UserCredentialListRoute = {
  name: "Users",
  path: `${CredentialsMenu.path}/users`,
  docPath: 'users-list',
  apiPath: 'credentials/users',
  exact: true,
  icon: 'icon-people',
  component: Loadable({
    loader: () => import("./views/credentials/users/list"),
    loading: Loading,
  })
};

export const UserCredentialEditRoute = {
  name: "User Credential",
  path: `${UserCredentialListRoute.path}/:id`,
  docPath: 'users-edit',
  apiPath: UserCredentialListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/credentials/users/edit"),
    loading: Loading,
  })
};

export const ConnectorListRoute = {
  name: "Connectors",
  path: `${DevelopmentMenu.path}/connectors`,
  docPath: 'connectors-list',
  apiPath: 'connectors',
  exact: true,
  icon: 'icon-equalizer',
  component: Loadable({
    loader: () => import("./views/connectors/list"),
    loading: Loading,
  }),
};

export const ConnectorEditRoute = {
  name: "Connector",
  path: `${ConnectorListRoute.path}/:id`,
  docPath: "connectors-edit",
  apiPath: ConnectorListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/connectors/edit"),
    loading: Loading,
  }),
};

export const EventListRoute = {
  name: "Events",
  path: `${DevelopmentMenu.path}/events`,
  docPath: "events-list",
  apiPath: 'events',
  exact: true,
  icon: 'icon-clock',
  component: Loadable({
    loader: () => import("./views/events/list"),
    loading: Loading,
  }),
};

export const EventEditRoute = {
  name: "Event",
  path: `${EventListRoute.path}/:id`,
  docPath: "events-edit",
  apiPath: EventListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/events/edit"),
    loading: Loading,
  }),
};

export const FlowListRoute = {
  name: "Flows",
  path: `${DevelopmentMenu.path}/flows`,
  docPath: "flow-list",
  apiPath: 'flows',
  exact: true,
  icon: 'icon-layers',
  component: Loadable({
    loader: () => import("./views/flows/list"),
    loading: Loading,
  }),
};

export const FlowEditRoute = {
  name: "Flow",
  path: `${FlowListRoute.path}/:id`,
  docPath: ["flow-edit", "history", "versioning"],
  testDocPath: 'flow-test',
  apiPath: FlowListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/flows/edit"),
    loading: Loading,
  }),
};

export const JsonHl7MappingListRoute = {
  name: "JSON to HL7v2",
  path: `${TransformationsMenu.path}/jsonhl7`,
  docPath: 'jsonHL7-list',
  apiPath: 'jsonhl7mappings',
  exact: true,
  icon: 'icon-puzzle',
  component: Loadable({
    loader: () => import("./views/transformations/jsonhl7/list"),
    loading: Loading,
  }),
};

export const JsonHl7MappingEditRoute = {
  name: "JSON to HL7v2",
  path: `${JsonHl7MappingListRoute.path}/:id`,
  docPath: 'jsonHL7-edit',
  testDocPath: 'transformation-test',
  apiPath: JsonHl7MappingListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/transformations/jsonhl7/edit"),
    loading: Loading,
  })
};

export const JsonJsonMappingListRoute = {
  name: "JSON to JSON",
  path: `${TransformationsMenu.path}/jsonjson`,
  docPath: 'jsontojson-list',
  apiPath: 'jsonjsonmappings',
  exact: true,
  icon: 'icon-puzzle',
  component: Loadable({
    loader: () => import("./views/transformations/jsonjson/list"),
    loading: Loading,
  })
};

export const JsonJsonMappingEditRoute = {
  name: "JSON to JSON",
  path: `${JsonJsonMappingListRoute.path}/:id`,
  docPath: 'jsontojson-edit',
  testDocPath: 'transformation-test',
  apiPath: JsonJsonMappingListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/transformations/jsonjson/edit"),
    loading: Loading,
  })
};

export const TemplatesListRoute = {
  name: "Templates",
  path: `${TransformationsMenu.path}/templates`,
  docPath: 'templates-list',
  apiPath: 'templates',
  exact: true,
  icon: 'icon-puzzle',
  component: Loadable({
    loader: () => import("./views/transformations/templates/list"),
    loading: Loading,
  })
};

export const TemplatesEditRoute = {
  name: "Template",
  path: `${TemplatesListRoute.path}/:id`,
  apiPath: TemplatesListRoute.apiPath,
  docPath: 'templates-edit',
  testDocPath: 'transformation-test',
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/transformations/templates/edit"),
    loading: Loading,
  })
};

export const MappingsListRoute = {
  name: "Mappings",
  path: `${TransformationsMenu.path}/mappings`,
  docPath: 'datamappings-list',
  apiPath: 'mappings',
  exact: true,
  icon: 'icon-puzzle',
  component: Loadable({
    loader: () => import("./views/transformations/mappings/list"),
    loading: Loading,
  })
};

export const MappingsEditRoute = {
  name: "Mapping",
  path: `${MappingsListRoute.path}/:id`,
  docPath: 'datamappings-edit',
  apiPath: MappingsListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/transformations/mappings/edit"),
    loading: Loading,
  })
};

export const RouteListRoute = {
  name: "Routes",
  path: `${DevelopmentMenu.path}/routes`,
  docPath: "route-list",
  apiPath: 'routes',
  exact: true,
  icon: 'icon-directions',
  component: Loadable({
    loader: () => import("./views/routes/list"),
    loading: Loading,
  }),
};

export const RouteEditRoute = {
  name: "Route",
  path: `${RouteListRoute.path}/:id`,
  docPath: "route-edit",
  apiPath: RouteListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/routes/edit"),
    loading: Loading,
  }),
};

export const ExportListRoute = {
  name: "Export Artifacts",
  path: "/export",
  docPath: 'export',
  exact: true,
  hidden: true,
  icon: "fa fa-upload",
  component: Loadable({
    loader: () => import("./views/artifacts/export"),
    loading: Loading,
  }),
};

export const ImportListRoute = {
  name: "Import Artifacts",
  path: "/import",
  docPath: 'import',
  exact: true,
  hidden: true,
  icon: "fa fa-download",
  component: Loadable({
    loader: () => import("./views/artifacts/import"),
    loading: Loading,
  }),
};

export const KeystoreListRoute = {
  name: "Keystores",
  path: `${ExtrasMenu.path}/keystores`,
  docPath: 'keystore-list',
  apiPath: 'keystores',
  exact: true,
  icon: 'icon-key',
  component: Loadable({
    loader: () => import("./views/extras/keystores/list"),
    loading: Loading,
  })
};

export const KeystoreEditRoute = {
  name: "Keystore",
  path: `${KeystoreListRoute.path}/:id`,
  docPath: 'keystore-edit',
  apiPath: KeystoreListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/extras/keystores/edit"),
    loading: Loading,
  })
};

export const TagListRoute = {
  name: "Tags",
  path: `${GroupingMenu.path}/tags`,
  docPath: 'tag-list',
  apiPath: 'tags',
  exact: true,
  icon: 'icon-tag',
  component: Loadable({
    loader: () => import("./views/tags/list"),
    loading: Loading,
  })
};

export const TagEditRoute = {
  name: "Tag",
  path: `${TagListRoute.path}/:id`,
  docPath: 'tag-edit',
  apiPath: TagListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/tags/edit"),
    loading: Loading,
  })
};

export const IntegrationListRoute = {
  name: "Integrations",
  path: `${GroupingMenu.path}/integrations`,
  docPath: 'integration-list',
  apiPath: 'integrations',
  exact: true,
  icon: 'icon-vector',
  component: Loadable({
    loader: () => import("./views/integrations/list"),
    loading: Loading,
  })
};

export const IntegrationEditRoute = {
  name: "Integration",
  path: `${IntegrationListRoute.path}/:id`,
  docPath: 'integration-edit',
  apiPath: IntegrationListRoute.apiPath,
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/integrations/edit"),
    loading: Loading,
  })
};


export const MessagesListRoute = {
  name: "Messages",
  path: `${ControlMenuRoute.path}/messages`,
  docPath: 'messages-list',
  exact: true,
  icon: 'icon-check',
  component: Loadable({
    loader: () => import("./views/control/messages/list"),
    loading: Loading,
  })
};

export const MessagesEditRoute = {
  name: "Successfully Processed Message",
  path: `${MessagesListRoute.path}/:id`,
  docPath: 'messages-edit',
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/control/messages/edit"),
    loading: Loading,
  })
};

export const ReprocessingListRoute = {
  name: "Reprocessing",
  path: `${ControlMenuRoute.path}/reprocessing`,
  docPath: 'reprocessing-list',
  exact: true,
  icon: 'icon-action-redo',
  component: Loadable({
    loader: () => import("./views/control/reprocessing/list"),
    loading: Loading,
  })
};

export const ReprocessingEditRoute = {
  name: "Failed Message",
  path: `${ReprocessingListRoute.path}/:id`,
  docPath: 'reprocessing-edit',
  exact: true,
  hidden: true,
  component: Loadable({
    loader: () => import("./views/control/reprocessing/edit"),
    loading: Loading,
  })
};

export const ConnectivityCheckRoute = {
  name: "Connectivity",
  path: `${TroubleshootingMenu.path}/connectivity/`,
  exact: true,
  icon: 'icon-direction',
  component: Loadable({
    loader: () => import("./views/troubleshooting/connectivity"),
    loading: Loading,
  })
};

export const ConfigurationCheckRoute = {
  name: "System",
  path: `${TroubleshootingMenu.path}/system/`,
  exact: true,
  icon: 'icon-screen-desktop',
  component: Loadable({
    loader: () => import("./views/troubleshooting/system"),
    loading: Loading,
  })
};

const routes = [
  { path: "/", exact: true, name: "Home", component: DefaultLayout, hidden: true },
  DashboardRoute, ImportListRoute, ExportListRoute,
  //---- Development ----
  DevelopmentMenu,
  ArtifactTesterRoute,
  ConnectorListRoute, ConnectorEditRoute,
  EventListRoute, EventEditRoute,
  FlowListRoute, FlowEditRoute,
  RouteListRoute, RouteEditRoute,
  TransformationsMenu,
  JsonHl7MappingListRoute, JsonHl7MappingEditRoute,
  JsonJsonMappingListRoute, JsonJsonMappingEditRoute,
  TemplatesListRoute, TemplatesEditRoute,
  MappingsListRoute, MappingsEditRoute,
  ExtrasMenu,
  KeystoreListRoute, KeystoreEditRoute,
  GroupingMenu,
  IntegrationListRoute, IntegrationEditRoute,
  TagListRoute, TagEditRoute,
  //---- Management ----
  ManagementMenu,
  GlobalConfigurationRoute,
  ConnectorConfigurationListRoute, ConnectorConfigurationEditRoute,
  RouteConfigurationListRoute, RouteConfigurationEditRoute,
  FlowConfigurationListRoute, FlowConfigurationEditRoute,
  CredentialsMenu,
  TokenCredentialListRoute, TokenCredentialEditRoute,
  UserCredentialListRoute, UserCredentialEditRoute,
  //---- Troubleshooting ----
  TroubleshootingMenu,
  ConnectivityCheckRoute,
  ConfigurationCheckRoute,
  //---- Control ----
  ControlMenuRoute,
  MessagesListRoute, MessagesEditRoute,
  ReprocessingListRoute, ReprocessingEditRoute,
];

export default routes;
